module.exports = __webpack_public_path__ + "img/CUI-for-contractors.4ae1c397.png";